import { FirebaseError } from 'firebase/app'
import { browserLocalPersistence, setPersistence, signInWithEmailAndPassword } from 'firebase/auth'
import pTimeout from 'p-timeout'
import React, { useState } from 'react'
import styled from 'styled-components'
import Screen from '~/components/screen'
import { fromUnknownError } from '~/prix'
import { buttonCSS } from '~/prix/react/components/button'
import { Input } from '~/prix/react/components/input'
import { auth } from '~/utils/client/auth'
import Pixels from '~/meta/pixels.svg'
import Logo from '~/meta/logo.svg'
import { ButtonVariants } from '~/components/buttonVariants'

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: white;

  form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1rem;

    border-radius: ${({ theme }) => theme.borderRadius};
    box-shadow: ${({ theme }) => theme.shadow(1)};
    margin-bottom: ${({ theme }) => theme.padding(1)};
    margin-bottom: calc(${({ theme }) => theme.padding(1)} + 1px);
    padding: ${({ theme }) => theme.padding(2)};
    background-color: white;
    width: 50%;

    output {
      color: ${({ theme }) => theme.colors.danger};
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      width: 80%;
    }
  }
`

const ImageWrapper = styled.div`
  width: 50%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;

  svg {
    width: 50%;
    height: 100%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    display: none;
  }
`

const Divider = styled.div`
  position: absolute;
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    height: 100%;
    width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    display: none;
  }
`

const FormWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.selectedBlue};
  height: 100%;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    background-image: ${({ theme }) =>
      `linear-gradient(to right, ${theme.colors.selectedBlue}, #4c95da)`};
    width: 100%;
    flex-direction: column;
    justify-content: flex-start;
    gap: 8rem;
  }
`

const LogoWhiteWrapper = styled.div`
  display: none;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: 6rem;
    svg {
      width: 100%;
      height: 100%;
    }
  }
`

export default function UserAuthScreen() {
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<Error | null>(null)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setIsLoading(true)
    setError(null)

    try {
      await setPersistence(auth, browserLocalPersistence)
      await pTimeout(signInWithEmailAndPassword(auth, email, password), 15000)
    } catch (error) {
      setError(fromUnknownError(error as FirebaseError))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Screen mustBeAuthenticated={false}>
      <Wrapper>
        <ImageWrapper>
          <Logo />
        </ImageWrapper>
        <Divider>
          <Pixels />
        </Divider>
        <FormWrapper>
          <LogoWhiteWrapper>
            <Logo width={200} />
          </LogoWhiteWrapper>
          <form onSubmit={handleSubmit}>
            <Input
              id='email'
              type='email'
              placeholder='Email'
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
            <Input
              id='password'
              type='password'
              placeholder='Senha'
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />

            {error ? <output>{error.message}</output> : null}

            <ButtonVariants
              type='submit'
              disabled={isLoading}
              isLoading={isLoading}
              variant='primary'
              style={{ padding: '1rem' }}
            >
              {isLoading ? 'Carregando' : 'Acessar'}
            </ButtonVariants>
          </form>
        </FormWrapper>
      </Wrapper>
    </Screen>
  )
}
